module.exports = __webpack_public_path__ + "img/fishRace.a4b97808.svg";